import React from 'react';

import {  IoCallOutline } from 'react-icons/io5';

const Call = ({ phoneNumber }) => {
  const handleCall = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  return (
    <div 
      onClick={handleCall} 
      className="bg-black rounded-full pl-[10px] pr-[10px] pt-[10px] pb-[10px] hover:scale-110" 
    >
      <IoCallOutline size={18} color="white" />
    </div>
  );
};

export default Call;
